export default function About() {
  return (
    <div>
      <div className="one" style={{ paddingTop: "40px" }}>
        <div className="standard_wrapper">
          <div className="page_content_wrapper">
            <div className="inner">
              <div className="one_half">
                <div className="image_classic_frame expand">
                  <div className="image_wrapper">
                    <img src="img/me.jpg" alt="" className="preview" />
                  </div>
                </div>
              </div>
              <div className="one_half last content_middle">
                <h2 className="ppb_title">About</h2>
                <hr className="title_break left" />
                <div>
                  <p>
                    Munstro-graphy (a play on my last name + photography). Photographer and Software Developer. Happily
                    married and a proud father to a few crazy cats. Car enthusiast, lover of Birria tacos, coffee
                    fanatic, and a huge PC gamer.
                  </p>
                  <p>
                    I enjoy exploring new destinations, getting inspired by other amazing photographers, and meeting new
                    people and hearing their stories! It's been a blast to meet so many car enthusiasts over the last
                    year! My ultimate goal is to continue learning and improving my craft, all the while having some
                    great memories with each shoot that I take.
                  </p>
                </div>
              </div>
              <br className="clear" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
